<template>
  <el-dialog :title="titleList[popType]" :visible.sync="formVisible" :close-on-click-modal="false" width="1000px" >
    <el-form ref="dataForm" label-position="right" :rules="formRules" :model="form"  size="small" label-width="130px">
      <Title v-if="[2].includes(popType)">用户基础信息</Title>
      <el-form-item label="客户姓名：" prop="name" v-if="[0,1,2].includes(popType)" :class="{'width100':[0,1].includes(popType)}">
        <el-input v-model="form.name" placeholder="请输入姓名" />
      </el-form-item>
      <el-form-item label="手机号：" prop="pho" v-if="[0,1,2].includes(popType)" :class="{'width100':[0,1].includes(popType)}">
        <el-input v-model="form.pho" placeholder="请输入手机号" maxlength="11" />
      </el-form-item>
      <!-- <el-form-item label="用友编码：" prop="customerAddDTO.code" v-if="popType==2">
        <el-input v-model="form.customerAddDTO.code" placeholder="根据用友返回" disabled />
      </el-form-item> -->
      <el-form-item label="升级身份：" prop="clevel" v-if="[2].includes(popType)">
        <el-select v-model="form.clevel" placeholder="请选择身份" @change="standingChange">
          <el-option :label="item.name" :value="item.level" v-for="item in standingList" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="折扣组:" prop="customerAddDTO.profitRatioId" v-if="[0,7].includes(popType)"
        :class="{'width100':popType==7}">
        <el-select v-model="form.customerAddDTO.profitRatioId" placeholder="请选择">
          <el-option :label="item.title" :value="item.id" v-for="item in discountList" :key="item.id"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="门店类型：" prop="shopType" v-if="[0,1,2].includes(popType)" :rules="[{required: true,message: '请选择门店类型',trigger: 'change'}]" :class="{'width100':[0,1].includes(popType)}">
        <el-select v-model="form.shopType" placeholder="请选择门店类型">
          <el-option :label="item" :value="item" v-for="(item,index) in options.storeTypeList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="日均门诊量：" prop="shopOutpatient" v-if="[0,1,2].includes(popType)" :rules="[{required: true,message: '请选择日均门诊量',trigger: 'change'}]" :class="{'width100':[0,1].includes(popType)}">
        <el-select v-model="form.shopOutpatient" placeholder="请选择日均门诊量">
          <el-option :label="item" :value="item" v-for="(item,index) in options.frequencyList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="员工数量：" prop="shopCount" v-if="[0,1,2].includes(popType)" :rules="[{required: true,message: '请选择员工数量',trigger: 'change'}]" :class="{'width100':[0,1].includes(popType)}">
        <el-select v-model="form.shopCount" placeholder="请选择员工数量">
          <el-option :label="item" :value="item" v-for="(item,index) in options.staffNum" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="正在开展项目：" prop="carryProjects" v-if="[0,1,2].includes(popType)" :rules="[{required: true,message: '请选择正在开展项目',trigger: 'change'}]" :class="{'width100':[0,1].includes(popType)}">
        <el-select v-model="form.carryProjects" multiple placeholder="请选择正在开展项目">
          <el-option :label="item" :value="item" v-for="(item,index) in options.projectList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属区域：" prop="addr" v-if="[0,1,2].includes(popType)" :class="{'width100':[0,1].includes(popType)}" :rules="[{required: true,message: '请选择省市区',trigger: 'change'}]">
        <el-cascader v-model="form.addr" :props="cascaderProps" collapse-tags :options="addressList" clearable placeholder="请选择省市区" @change="regionChange"></el-cascader>
      </el-form-item>
      <!-- <el-form-item label="详细地址：" prop="addrDetail">
        <el-input v-model="form.customerAddDTO.addrDetail" placeholder="请输入详细地址" />
      </el-form-item> -->
      <el-form-item label="微信号：" prop="wechat">
        <el-input v-model="form.wechat" placeholder="请输入客户微信号" />
      </el-form-item>
      <el-form-item label="意向度：" prop="intentionLevel" :class="{'width100':[0,1].includes(popType)}">
        <el-select v-model="form.intentionLevel" placeholder="请选择客户意向度">
          <el-option label="高" value="高"></el-option>
          <el-option label="中" value="中"></el-option>
          <el-option label="低" value="低"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注：" prop="note" class="width100" :class="{'width100':[0,1].includes(popType)}">
        <el-input v-model="form.note" placeholder="请输入备注" />
      </el-form-item>

      <el-form-item label="所属业务：" prop="parentId" v-if="[2].includes(popType)">
        <el-select v-model="form.parentId" placeholder="请选择业务员" @change="businessChange">
          <el-option :label="item.name" :value="item.id" v-for="item in businessList" :key="item.id"></el-option>
        </el-select>
        <span class="font12 c-8F8E8E">不选择根据区域默认分配</span>
      </el-form-item>
      <el-form-item label="业务线：" prop="" class="width100" v-if="popType==2">
        <el-input v-model="customerLine" placeholder="根据选择的业务员自动读取" disabled />
      </el-form-item>
      <el-form-item label="业务标签：" prop="customerTagList" class="width100" v-if="popType==2">
        <el-cascader v-model="form.customerTagList" :options="labelList" :props="labelProps" :show-all-levels="false" placeholder="请选择业务标签">
        </el-cascader>
      </el-form-item>
      <el-form-item label="技术老师：" prop="technicianId" v-if="[2].includes(popType)">
        <el-select v-model="form.technicianId" placeholder="请选择技术老师" @change="technicianChange">
          <el-option :label="item.realName" :value="item.id" v-for="item in technicianList" :key="item.id"></el-option>
        </el-select>
        <span class="font12 c-8F8E8E">不选择根据区域默认分配</span>
      </el-form-item>
      <el-form-item label="技术线：" prop="" class="width100" v-if="popType==2">
        <el-input v-model="technicalLine" placeholder="根据技术老师自动读取" disabled />
      </el-form-item>
      <el-form-item label="技术标签：" prop="customerJSTagList" class="width100" v-if="popType==2">
        <el-cascader v-model="form.customerJSTagList" :options="labelList" :props="labelProps" :show-all-levels="false" placeholder="请选择技术标签">
        </el-cascader>
      </el-form-item>
      <template v-if="popType==2">
        <Title>认证信息</Title>
        <el-form-item label="认证类型：" prop="customerCertificatesAddDTO.certificatesType" class="width100">
          <el-select v-model="form.customerCertificatesAddDTO.certificatesType" placeholder="请选择认证类型" clearable @change='handleTypeChange'>
            <el-option label="企业认证" :value="1"></el-option>
            <el-option label="个人认证" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <!-- {{form.customerCertificatesAddDTO.certificatesType}} -->
        <template v-if="form.customerCertificatesAddDTO.certificatesType==1">
          <el-form-item label="门店类型：" prop="customerCertificatesAddDTO.companyType" class="width100" :rules="[{required: form.customerCertificatesAddDTO.certificatesType==1,message: '请选择门店类型',trigger: 'change'}]">
            <el-select v-model="form.customerCertificatesAddDTO.companyType" placeholder="请选择门店类型">
              <el-option :label="item" :value="item" v-for="(item,index) in companyOption" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="企业全称：" prop="customerCertificatesAddDTO.companyName" :rules="[{required: form.customerCertificatesAddDTO.certificatesType==1,message: '请输入企业全称',trigger: 'blur'}]">
            <el-input v-model="form.customerCertificatesAddDTO.companyName" placeholder="请输入企业名称" />
          </el-form-item>
          <el-form-item label="资质证件类型：" prop="customerCertificatesAddDTO.companyZiZhi" :rules="[{required: form.customerCertificatesAddDTO.certificatesType==1,message: '请选择资质证件类型',trigger: 'change'}]">
            <el-select v-model="form.customerCertificatesAddDTO.companyZiZhi" placeholder="请选择资质证件类型/医疗机构职业许可证/营业执照" @change="handleCompany">
              <el-option label="医疗机构职业许可证" :value="2"></el-option>
              <el-option label="营业执照" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="资质证件凭证：" prop="customerCertificatesAddDTO.certificatesImg" class="width100" :rules="[{required: form.customerCertificatesAddDTO.certificatesType==1,message: '请上传资质证件凭证',trigger: 'change'}]">
            <div class="flexs">
              <el-upload class="avatar-uploader" :action="uploadImgUrl" :show-file-list="false" :on-success="handleAvatarSuccess">
                <img v-if="form.customerCertificatesAddDTO.certificatesImg" :src="form.customerCertificatesAddDTO.certificatesImg" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="统一社会信用代码/登记号：" prop="customerCertificatesAddDTO.code" :rules="[{required:  form.customerCertificatesAddDTO.certificatesType==1,message: '请输入统一社会信用代码/登记号',trigger: 'blur'}]">
            <el-input v-model="form.customerCertificatesAddDTO.code" placeholder="根据资质证件凭证读取" disabled />
          </el-form-item>
          <el-form-item label="纳税人识别号：" prop="customerCertificatesAddDTO.taxpayerCode" :rules="[{required: form.customerCertificatesAddDTO.certificatesType==1,message: '请输入纳税人识别号',trigger: 'blur'}]">
            <el-input v-model="form.customerCertificatesAddDTO.taxpayerCode" placeholder="请输入纳税人识别号" :disabled="form.customerCertificatesAddDTO.companyZiZhi==1" />
          </el-form-item>
        </template>
        <template v-if="form.customerCertificatesAddDTO.certificatesType==2">
          <el-form-item label="姓名：" prop="customerCertificatesAddDTO.companyName" class="width100" :rules="[{required: form.customerCertificatesAddDTO.certificatesType==2,message: '请输入姓名',trigger: 'blur'}]">
            <el-input v-model="form.customerCertificatesAddDTO.companyName" placeholder="请输入姓名" />
          </el-form-item>
          <el-form-item label="身份证号：" prop="customerCertificatesAddDTO.code" class="width100" :rules="[{required: form.customerCertificatesAddDTO.certificatesType==2,message: '身份证号未识别',trigger: 'blur'}]">
            <el-input v-model="form.customerCertificatesAddDTO.code" placeholder="根据上传身份证图片读取" disabled />
          </el-form-item>
          <el-form-item label="上传身份证：" prop="advertisingUrl" class="width100">
            <!-- :rules="[{required: true,message:'请上传身份证',trigger: 'change'},{validator: checkCard,trigger: 'change'}]"> -->
            <div class="flexs">
              <el-upload class="card-uploader" :action="uploadImgUrl" :show-file-list="false" :on-success="handleCardSuccess">
                <img v-if="cardImageUrl" :src="cardImageUrl" class="avatar">
                <img src="@/assets/card.png" alt="" v-else />
                <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
              </el-upload>
              <el-upload class="card-uploader" :action="uploadImgUrl" :show-file-list="false" :on-success="handleCardBackSuccess">
                <img v-if="cardBackImageUrl" :src="cardBackImageUrl" class="avatar">
                <img src="@/assets/card1.png" alt="" v-else />
              </el-upload>
              <!-- <imageUpload v-model="form.advertisingUrl" width="54" height="54" />
              <imageUpload v-model="form.advertisingUrl" width="54" height="54" /> -->
              <!-- <span class="hint">图片限制数量1张<br />建议尺寸710x320像素以上</span> -->
            </div>
          </el-form-item>
        </template>
      </template>

      <template v-if="[2].includes(popType) &&form.clevel && form.clevel!=8">
        <Title>报名费用</Title>
        <el-form-item label="报名费用：" prop="customerRegistrationAddDTO.fee" class="width100" :rules="[{ required: true, message: '请输入报名费用', trigger: 'blur' }]">
          <el-input v-model="form.customerRegistrationAddDTO.fee" placeholder="请输入报名费用" />
        </el-form-item>
        <el-form-item label="付款凭证：" prop="customerRegistrationAddDTO.registrationPayList" class="width100" :rules="[{ required: true, message: '请上传付款凭证', trigger: 'change' }]">
          <div class="flexs">
            <el-upload :action="uploadImgUrl" list-type="picture-card" :file-list="payVoucher" :on-success="handleImgUpload" :on-remove="handleRemove">
              <i class="el-icon-plus"></i>
            </el-upload>
            <span class="hint">支持上传多张</span>
            <!-- <span class="font12 c-main ml20 c-pointer">生成付款码</span> -->
          </div>
        </el-form-item>
        <el-form-item label="申请凭证：" prop="customerRegistrationAddDTO.applyVoucher" class="width100">
          <div class="flexs">
            <el-upload :action="uploadImgUrl" list-type="picture-card" :file-list="applyVoucher" :on-success="handleImgUpload1" :on-remove="handleRemove1">
              <i class="el-icon-plus"></i>
            </el-upload>
            <span class="hint">支持上传多张</span>
          </div>
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import ImageUpload from "@/components/ImageUpload";
import clientListApi from '@/api/client/clientList'
import sysToolsApi from '@/api/sys/tools'
import clientLabelApi from '@/api/client/label'
import technicianInfoApi from '@/api/technical/technicianInfo'
import sysDataconstantApi from '@/api/config/sysDataconstant'

function initFormBean() {
  const formBean = {
    name: null,
    pho: null,
    levelId: null,
    shopType: null,
    shopOutpatient: null,
    shopCount: null,
    carryProjects: null,
    addr: null,
    wechat: null,
    intentionLevel: null,
    note: null,
    parentId: null,
    customerTagList: null,
    technicianId: null,
    customerJSTagList: null,
    customerType: 3,
    source: '后台录入',
    clevel: null,
    customerCertificatesAddDTO: {
      certificatesType: null
    },
    customerRegistrationAddDTO: {
      fee: null,
      registrationPayList: null,
      applyVoucher: null
    }
  }
  return formBean
}

export default {
  //popType 0:新增 1:编辑 2:身份升级 3:转给其他人
  props: {
    standingList: Array,
    discountList: Array,
    configList: Array,
    labelList: Array,
    addressList: Array,
    technicianList: Array,
    businessList: Array,
    popType: Number
  },
  components: {
    ImageUpload
  },
  data() {
    return {
      uploadImgUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload', // 上传的图片服务器地址
      uploadImgUrl1: process.env.VUE_APP_BASE_API + '/sys/tools/idCardOCR', // 上传的图片服务器地址
      titleList: ['添加线索', '编辑线索', '身份升级', '转给其他人'],
      form: initFormBean(),
      technicalLine: '', //技术线
      customerLine: '', //业务线
      formVisible: false,
      isLoading: false,
      formRules: {
        name: [{
          required: true,
          message: '请输入客户姓名',
          trigger: 'blur'
        }],
        pho: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }],
        clevel: [{
          required: true,
          message: '请选择客户身份',
          trigger: 'change'
        }],
      },
      options: {
        projectList: [], //   正在开展项目
        storeTypeList: [], //门店类型
        frequencyList: [], //日均门诊人次
        staffNum: [] //员工数量
      },
      cascaderProps: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child',
        // multiple: true
      },
      labelProps: {
        label: 'name',
        value: 'id',
        children: 'children',
        multiple: true
      },
      payVoucher: [],
      applyVoucher: [],
      cardImageUrl: '',
      cardBackImageUrl: '',
      companyOption: [],
      selectItems: []
    }
  },
  created() {

  },
  methods: {
    // 获取系统配置
    getConfig() {
      sysDataconstantApi.fetchBatchCode({
        code: 'shopType'
      }).then(({
        data
      }) => {
        this.companyOption = data.list[0].content.split(',')
        // this.configList=data.list
        // console.log("配置: ",data);
      })
    },
    handleTypeChange(e) {
      // console.log('e: ', e);
      // if (this.popType == 6) {
      this.form.customerCertificatesAddDTO = {}
      this.form.customerCertificatesAddDTO.certificatesType = e
      this.cardImageUrl = ''
      this.cardBackImageUrl = ''
      // }
      if (e == 2) {
        // this.formRules['advertisingUrl']=[{ validator: this.checkCard, trigger: 'change' }]
        // console.log('this.formRules:1111 ', this.formRules);
        this.$set(this.formRules, 'advertisingUrl', [{
          validator: (rule, value, callback) => {
            // console.log('============1', this.form.customerCertificatesAddDTO.certificatesType, this.popType);
            if (this.form.customerCertificatesAddDTO.certificatesType == 2 && (!this
              .cardImageUrl || !this.cardBackImageUrl)) {
              callback(new Error('请上传身份证'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }])

      }
    },
    handleCompany(e) {
      // console.log('e: ',e);
      if (!this.form.customerCertificatesAddDTO.code) return
      if (e == 2) {
        this.$set(this.form.customerCertificatesAddDTO, 'taxpayerCode', this.form.customerCertificatesAddDTO.code)
      } else {
        this.$set(this.form.customerCertificatesAddDTO, 'taxpayerCode', '')
      }
    },
    handleCardSuccess(res, file) {
      this.cardImageUrl = res.data
      sysToolsApi.idCardOCR({
        imageUrl: res.data
      }).then((res) => {
        this.$set(this.form.customerCertificatesAddDTO, 'code', res.data.idNum)
        // console.log('res: ',res);
        // this.form.customerCertificatesAddDTO.code=res.data.regNum
        // console.log('this.form.customerCertificatesAddDTO.companyZiZhi: ',this.form.customerCertificatesAddDTO.companyZiZhi);

      })
    },
    handleCardBackSuccess(res, file) {
      this.cardBackImageUrl = res.data
    },
    handleAvatarSuccess(res, file) {
      // this.form.customerCertificatesAddDTO.certificatesImg = res.data;
      this.$set(this.form.customerCertificatesAddDTO, 'certificatesImg', res.data)
      sysToolsApi.bizLicenseOCR({
        imageUrl: res.data
      }).then((res) => {
        // console.log('res: ',res);
        this.$set(this.form.customerCertificatesAddDTO, 'code', res.data.regNum)
        if (this.form.customerCertificatesAddDTO.companyZiZhi == 1) {
          // console.log('=============');
          this.$set(this.form.customerCertificatesAddDTO, 'taxpayerCode', res.data.regNum)
          // this.form.customerCertificatesAddDTO.taxpayerCode=res.data.regNum
        }
        // this.form.customerCertificatesAddDTO.code=res.data.idNum
      })
      // console.log('file: ',this.form.customerCertificatesAddDTO.certificatesImg);
    },

    handleImgUpload(response, file, fileList) {
      if (file && file.response) {
        this.payVoucher.push({
          url: file.response.data
        })
        this.form.customerRegistrationAddDTO.registrationPayList = this.payVoucher.length ? this.payVoucher.map(i =>
        ({
          payImg: i.url,
          state: 0
        })) : [];
      }
    },
    handleRemove(file, fileList) {
      // console.log('12',file, fileList);
      this.payVoucher = fileList
      this.form.customerRegistrationAddDTO.registrationPayList = this.payVoucher.length ? this.payVoucher.map(i => ({
        payImg: i.url,
        state: 0
      })) : [];
    },
    handleImgUpload1(response, file, fileList) {
      if (file && file.response) {
        this.applyVoucher.push({
          url: file.response.data
        })
      }
    },
    handleRemove1(file, fileList) {
      // console.log('22',file, fileList);
      this.applyVoucher = fileList
    },
    resetForm() {
      this.form = initFormBean()
      this.applyVoucher = []
      this.payVoucher = []
      this.cardImageUrl = ''
      this.cardBackImageUrl = ''
    },
    handleUpdate({
      row,
      command
    }) {
      // console.log('popType: ',this.popType);
      this.resetForm()
      if (command) {
        console.log('command: ', row);
        this.form.name = row.customerName
        this.form.pho = row.customerPhone
        // this.form.levelId = row.
        this.form.shopType = row.storeType
        this.form.shopOutpatient = row.dailyOutpatientVisits
        this.form.shopCount = row.staffNum
        this.form.carryProjects = row.projectId ? row.projectId.split(',') : ''
        this.form.addr = [row.provinceCode, row.cityCode, row.regionCode]
        this.form.wechat = row.wechatNumber
        this.form.intentionLevel = row.intentionality == 1 ? '高' : row.intentionLevel == 2 ? '中' : '低'
        this.form.note = row.remark
        if (row.customerTagList && row.customerTagList.length) {
          this.form.customerTagList = row.customerTagList.map(item => {
            let arr = []
            this.labelList.map(i => {
              // console.log('i.children.findIndex(i.id==item.id): ',i.children.findIndex(it=>it.id==item.id));
              if (i.children.findIndex(it => it.id == item.id) != -1) { arr = [i.id, item.id] }
            })
            return arr
          })
        }
        console.log('this.form: ', this.form);
      }
      this.getConfig()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
        this.configList.forEach(i => {
          if (i.code == "carryProjects") this.options.projectList = i.content.split(',')
          if (i.code == "shopType") this.options.storeTypeList = i.content.split(',')
          if (i.code == "dayAVGOutpatients") this.options.frequencyList = i.content.split(',')
          if (i.code == "employeeNums") this.options.staffNum = i.content.split(',')
          // console.log('staffNum: ', this.options.staffNum);
        })
      })
    },
    doCreate() {
      // console.log('-----12----',this.payVoucher);
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.isLoading = true
          // console.log('this.form: ', this.form);
          // return
          if (!this.popType) {
            let params = {
              ...this.form,

            }
            if ([0, 1, 2].includes(this.popType)) {
              params.carryProjects = params.carryProjects ? params.carryProjects.toString() : ''
            }
            this.form.customerRegistrationAddDTO.applyVoucher = this.applyVoucher.length ? this.applyVoucher.map(
              i => i.url)
              .join(',') : '';
            if (!this.form.customerCertificatesAddDTO.certificatesType) {
              params.customerCertificatesAddDTO = null
            } else if (this.form.customerCertificatesAddDTO.certificatesType == 2) {
              // 个人认证
              this.form.customerCertificatesAddDTO.certificatesImg =
                `${this.cardImageUrl}#${this.cardBackImageUrl}`
              this.form.customerCertificatesAddDTO.companyZiZhi = 3
            }
            if (!this.form.clevel || this.form.clevel == 8) params.customerRegistrationAddDTO = null
            if (this.form.addr.length) {
              params.addrProvinceCode = params.addr[0]
              params.addrCityCode = params.addr[1]
              params.addrAreaCode = params.addr[2]
            }
            delete params.addr
            params.customerTagList = params.customerTagList ? params.customerTagList.map(i => i[1]) : null
            params.customerJSTagList = params.customerJSTagList ? params.customerJSTagList.map(i => i[1]) : null
            console.log('params----: ', params);
            params.isIntern = 0
            params.state = 2
            // params.registrationType=1
            // return
            params.isUseParentWallet = 0
            clientListApi.create(params).then((data) => {
              this.technicalLine = ''
              this.customerLine = ''
              this.postCallback(data)
            }).catch(res => {
              this.isLoading = false
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    postCallback(data) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
      this.isLoading = false
    },
    standingChange(e) {
      // this.form.customerAddDTO.profitRatioId = this.standingList.find(i => i.level == e).defaultProfitRatioId
      console.log('e: ', e);
    },
    // 选择区域
    regionChange(e) {
      // if (!e) return
      technicianInfoApi.listForMini({
          // isGetAllParent: true,
          // districtCode: e[e.length - 1],
          // levelIdSortSign: 1
      }).then(({
        data
      }) => {
        if (data.length) {
          const defaultTech = data.find(i => i.levelId === 3) || data[data.length - 1]
          this.form.technicianId = defaultTech.id
          this.technicianChange(defaultTech.id)
        }
      })
      clientListApi.getListPageForMini({
        isGetAllParent: true,
        districtCode: e[e.length - 1],
        levelIdSortSign: 1,
        customerTypes: 2
      }).then((({
        data
      }) => {
      
        // clientListApi.getListPageForMini({districtCode:e[e.length-1],customerTypes:2}).then((({data})=>{
        if (data.list.length) {
          this.form.parentId = data.list[data.list.length - 1].id
          this.businessChange(data.list[data.list.length - 1].id)
        }
      }))
    },
    // 技术老师选择
    technicianChange(e) {
      let obj = this.technicianList.find(i => i.id == e)
      console.log('obj: ', obj);
      let str = `${obj.realName}【${obj.levelName}】`
      let arr = []
      if (obj.parentList.length) {
        arr = obj.parentList.map(i => (`${i.realName}【${i.levelName}】`))
      }
      this.technicalLine = `${str}${arr.length ? ' - ' : ''}${arr.join(' - ')}`
    },
    // 业务员选择
    businessChange(e) {
      let obj = this.businessList.find(i => i.id == e)
      console.log('obj111: ', obj);
      let str = `${obj.name}【${obj.levelName}】 `
      let arr = []
      if (obj.parentList && obj.parentList.length) {
        arr = obj.parentList.map(i => (`${i.name}【${i.levelName}】`))
      }
      this.customerLine = `${str}${arr.length ? ' - ' : ''}${arr.join(' - ')}`
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-upload--picture-card {
  width: 54px;
  height: 54px;
  line-height: 62px;
}

::v-deep .el-upload-list__item {
  width: 54px;
  height: 54px;
}

::v-deep .el-select {
  width: 100%;
}

::v-deep .el-cascader {
  width: 100%;
}

::v-deep .el-dialog {
  max-height: 88vh;
  margin-top: 6vh !important;
}

::v-deep .el-form {
  max-height: 64vh !important;
  overflow-y: auto;
}

.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

.el-form-item--small.el-form-item.width100 {
  width: 97%;
}

::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 54px;
  height: 54px;
  line-height: 54px;
  text-align: center;
}

.avatar {
  width: 54px;
  height: 54px;
  display: block;
}

.card-uploader img {
  height: 132px;
  width: 194px;
  margin-right: 56px;
}
</style>
